// ABOUTME: Context and hook for managing copy/paste state across calendar components.
// ABOUTME: CopyProvider (sibling file) owns the state; useCopyContext reads it.

import type React from "react"
import { createContext, useContext } from "react"
import type { CalendarItem } from "@/graphql/main/gql/graphql"
import type { ActivityType } from "@/graphql/main/gql/graphql"

export interface CopyContextProps {
  isCopyActivities: {
    isCopyDayRations: boolean
    isCopyWeekRations: boolean
    isCopyDayWorkout: boolean
    isCopyWeekWorkout: boolean
    isCopyDayEvent: boolean
    isCopyWeekEvent: boolean
    isCopyDayRest: boolean
    isCopyWeekRest: boolean
  }
  handleCopy: (
    val: boolean,
    type: "day" | "week",
    typeActivity: ActivityType.Menu | ActivityType.Workout | ActivityType.Event | ActivityType.Rest,
  ) => void
  /** Batch copy flag setter — flips multiple activity types in a single call so
   *  "Copy all" can mark Workout + Event + Menu simultaneously. */
  handleCopyMulti: (val: boolean, type: "day" | "week", activityTypes: ActivityType[]) => void
  setCopiedActivities: React.Dispatch<React.SetStateAction<CalendarItem[]>>
  copiedActivities: CalendarItem[]
}

export const CopyContext = createContext<CopyContextProps | undefined>(undefined)

export const useCopyContext = () => {
  const context = useContext(CopyContext)
  if (!context) {
    throw new Error("useCopyContext must be used within a CopyProvider")
  }
  return context
}
